import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import { usersApi as users } from "api";
import { finishSignIn, pendingClassId } from "lib/session";

import JoiningBanner from "features/auth/JoiningBanner";
import { Button, Field } from "components/ui";
import { OCCUPATIONS, professionOf, splitErrors } from "features/account/profile";

// A taken email shows on the email field instead of above the form.
function registerErrors(message) {
  if (typeof message === "string" && /email/i.test(message)) return { email: "This email already has an account. Try logging in." };
  return splitErrors(message, "Could not create your account. Please try again.");
}

function RegisterForm({ history, location }) {
  const dispatch = useDispatch();
  const [Form, setForm] = useState({
    name: "",
    email: new URLSearchParams(location?.search).get("email") ?? "",
    password: "",
    profession: "",
    otherProfession: "",
  });
  const [Errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const classId = pendingClassId();

  // Read the event now: React 16 pools events, so e.target is null by the
  // time a functional state update runs.
  const set = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  function submit(e) {
    e.preventDefault();
    setErrors({});
    setIsSubmitting(true);

    const email = Form.email.trim();
    users
      .register({
        name: Form.name.trim(),
        email,
        password: Form.password,
        profession: professionOf(Form),
      })
      // Sign-up also signs the new account in; carry on to wherever they
      // were heading (usually the class they clicked Enroll on).
      .then((res) => history.push(finishSignIn(res.data, dispatch)))
      .catch((err) => {
        setIsSubmitting(false);
        setErrors(registerErrors(err?.response?.data?.message));
      });
  }

  return (
    <form onSubmit={submit} noValidate>
      {classId && <JoiningBanner classId={classId} action="Create a free account" />}
      {Errors.form && (
        <p className="yc-alert is-error" role="alert">
          {Errors.form}
        </p>
      )}
      <Field label="Full name" name="name" value={Form.name} onChange={set} error={Errors.name} autoComplete="name" required />
      <Field label="Email address" name="email" type="email" value={Form.email} onChange={set} error={Errors.email} autoComplete="email" required />
      <Field label="Password" name="password" type="password" value={Form.password} onChange={set} error={Errors.password} hint="At least 8 characters." autoComplete="new-password" required />
      <Field label="Occupation" name="profession" value={Form.profession} onChange={set} options={OCCUPATIONS} error={Errors.profession} />
      {Form.profession === "others" && (
        <Field label="Your occupation" name="otherProfession" value={Form.otherProfession} onChange={set} placeholder="e.g. Marketing Executive" />
      )}
      <Button type="submit" block size="lg" disabled={isSubmitting} className="yc-auth-submit">
        {isSubmitting ? "Creating your account…" : "Sign Up"}
      </Button>
      <p className="yc-auth-switch">
        Already have an account?{" "}
        <Link to="/login" className="yc-link">
          Log in
        </Link>
      </p>
    </form>
  );
}

export default withRouter(RegisterForm);
